import '.eq{height:100svh;}.ssr-plugin'
import '.er{width:100svw;}.ssr-plugin'
import { useClient } from '@based/sdk/react'
import { styled } from 'inlines'
import { ReactNode, useState } from 'react'
import { useUsers } from '../../hooks/useUsers.js'
import { useBasedEndpoints } from '../../providers/Endpoints/index.js'
import { AuthContainer } from '../AuthPage/AuthContainer.js'
import { Button } from '../Button/index.js'
import { FileInput } from '../FileInput/index.js'
import { Separator } from '../Separator/index.js'
import { Text } from '../Text/index.js'
import { TextInput } from '../TextInput/index.js'

export type OnboardingProps = {
  appName: ReactNode
  onFinish?: (values: { name: string; picture?: string }) => void
  onLogout?: () => void
  logoutEndpoint?: string
  accountSettingsUpdateEndpoint?: string
}

export const Onboarding = ({
  appName,
  onFinish,
  onLogout,
  logoutEndpoint = 'ui-auth-logout',
  accountSettingsUpdateEndpoint = 'ui-account-settings-update',
}: OnboardingProps) => {
  const [picture, setPicture] = useState<string>()
  const client = useClient()
  const endpoints = useBasedEndpoints()
  const { me } = useUsers()
  const [newName, setNewName] = useState(me?.name)

  onFinish =
    onFinish ||
    (async (values) => {
      await client.call(accountSettingsUpdateEndpoint, {
        ...values,
        status: 'active',
      })
    })

  onLogout =
    onLogout ||
    (async () => {
      try {
        await client.call(logoutEndpoint)
      } catch {}
      await client.setAuthState({})
    })

  return (
    <div className="eq er"
    >
      <AuthContainer title="Set up your account" subtitle={appName}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            padding: '0 6px',
          }}
        >
          <TextInput label="Name" value={newName} onChange={setNewName} />
          <FileInput
            accept="image/*"
            multiple={false}
            label="Avatar (optional)"
            stream="db:file-upload"
            onChange={(_value, _progress, url) => {
              if (url) {
                setPicture(url as string)
              }
            }}
          />
        </div>
        <div
          style={{
            padding: '0 6px',
          }}
        >
          <Button
            align="left"
            variant="fill"
            trailIcon="arrow-right"
            style={{ alignSelf: 'flex-start' }}
            onClick={() => {
              typeof onFinish === 'function' &&
                onFinish({
                  name: newName,
                  picture,
                })
            }}
          >
            Finish setup
          </Button>
        </div>
        <Separator />
        <div
          style={{
            gap: 4,
          }}
        >
          <div
            style={{
              padding: '0 6px',
            }}
          >
            <Text variant="subtext-medium" color="neutral60">
              Something wrong?
            </Text>
          </div>
          <Button
            size="small"
            variant="ghost"
            trailIcon="arrow-right"
            style={{ alignSelf: 'flex-start' }}
            onClick={() => {
              typeof onLogout === 'function' && onLogout()
            }}
          >
            Log out
          </Button>
        </div>
      </AuthContainer>
    </div>
  )
}
